import stepper1 from '../../assets/Images/stepper/stepper1.svg'
import stepper2 from '../../assets/Images/stepper/stepper2.svg'
import stepper3 from '../../assets/Images/stepper/stepper3.svg'
import stepper4 from '../../assets/Images/stepper/stepper4.svg'
import stepper5 from '../../assets/Images/stepper/stepper5.svg'
import stepper6 from '../../assets/Images/stepper/stepper6.svg'
import { applicationStatus } from '../../layouts/Applications/constant'
import { APPLICATIONAPPROVED, APPLICATIONREJECTED, APPLICATIONSUBMITTED, SITEAPPROVED, SITEREJECTED } from '../../layouts/ViewApplication/constant'

const steps = [
  {
    img: stepper1,
    description: 'Download EnergyHub and Enphase Terms and conditions document and get it signed by homeowner',
  },
  {
    img: stepper2,
    description: 'Fill homeowner details, upload signed T&C document and submit the application on this portal for APS review',
  },
  {
    img: stepper3,
    description: 'Submitted Application now goes to APS for approval or rejection via EnergyHub',
  },
  {
    img: stepper4,
    description: 'Once approved by APS, complete the site commissioning. Site goes live with a unique Enphase Site ID. Provide Enphase Site ID via Intake Portal for Enphase to map the application.',
  },
  {
    img: stepper5,
    description: 'The Application is now submitted for Enphase Review',
  },
  {
    img: stepper6,
    description: 'Once approved by Enphase, you’ve got the site successfully enrolled in the program.',
  },
]

const stepsMapper = {
  [APPLICATIONREJECTED]: 'Approved/ Rejected by APS',
  [SITEREJECTED]: 'Approved/ Rejected by Enphase'
}

const psegStepsMapper = {
  [APPLICATIONREJECTED]: 'Application approved/ rejected by Enphase',
  [SITEREJECTED]: 'Application approved/ rejected by PSEG'
}

const ctessStepsMapper = {
  [APPLICATIONREJECTED]: 'Application approved/ rejected by Enphase',
  [SITEREJECTED]: 'Application approved/ rejected by Utility'
}

const labelMapper = {
  [APPLICATIONAPPROVED]: 'Approved by APS',
  [APPLICATIONREJECTED]: 'Rejected by APS',
  [SITEAPPROVED]: 'Approved by Enphase',
  [SITEREJECTED]: 'Rejected by Enphase',
  [APPLICATIONSUBMITTED]: 'Application submitted for APS Review'
}

const stepperMapper = {
  [APPLICATIONAPPROVED]: 'Approved/ Rejected by APS',
  [APPLICATIONREJECTED]: 'Approved/ Rejected by APS',
  [SITEAPPROVED]: 'Approved/ Rejected by Enphase',
  [SITEREJECTED]: 'Approved/ Rejected by Enphase',
  [APPLICATIONSUBMITTED]: 'Submit Application for APS Review'
}

const getLabel = (label, status) => {
  if (stepperMapper[status] === label && (status === APPLICATIONAPPROVED || status === APPLICATIONREJECTED || status === SITEAPPROVED || status === SITEREJECTED)) {
    return labelMapper[status]
  } else if (applicationStatus[status] && applicationStatus[status][2] > 2 && label === stepsMapper[APPLICATIONREJECTED]) {
    return labelMapper[APPLICATIONAPPROVED]
  } else if (applicationStatus[status] && applicationStatus[status][2] > 1 && label === stepperMapper[APPLICATIONSUBMITTED]) {
    return labelMapper[APPLICATIONSUBMITTED]
  }
  return label
}

export {
  steps,
  stepsMapper,
  labelMapper,
  psegStepsMapper,
  ctessStepsMapper,
  getLabel
}